import React, { useEffect, useState } from "react";
import MainModal from "./MainModal";
import { sendEmailInvoice, updateFixedPrice } from "../../utils/ParserUtilities";

import "../../styles/modal/invoice-modal.css";
import Jobin from "jobin-client";
import { useStateValue } from "../../state/context";

const InvoiceModal = ({ jobDetails, user, isVisible, onClose, currentPrice }) => {
    const [{ agent }] = useStateValue();

    const [newPrice, setNewPrice] = useState(currentPrice);
    const [email, setEmail] = useState(user.get("email"));
    const [disabled, setDisabled] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [ammountError, setAmmountError] = useState(true);

    useEffect(() => {
        handleAmmountChange(newPrice)
        handleChangeEmail(email)
    }, [])

    const onSendEmail = async () => {
        if (newPrice != currentPrice) {
            let newPayment = await updateFixedPrice(jobDetails.job.id, parseFloat(newPrice));

            await Jobin.PDF.remakeBill(newPayment);

            jobDetails.fetchData()
        }

        await sendEmailInvoice({ jobId: jobDetails.job.id, userId: user.id, agentId: agent.agentId, ammount: newPrice, email: email })
    }
    const handleAmmountChange = (ammount) => {
        setNewPrice(ammount);
        if (ammount >= 1) {
            setAmmountError(false);
            setDisabled(false)
        } else {
            setDisabled(true)
            setAmmountError(true)
        };
    }
    const handleChangeEmail = (email) => {
        setEmail(email);
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/.test(email)) {
            setEmailError(false);
            setDisabled(false)
        } else {
            setDisabled(true)
            setEmailError(true)
        };
    }

    return (
        <MainModal
            gigant={true}
            title={"Enviar Factura"}
            subtitle={"Enviaras la factura del servicio al correo electronico del cliente. El precio actual del servicio es: " + currentPrice + "€ (sin IVA)"}
            isVisible={isVisible}
            onClose={onClose}
        >
            <div className="invoice-modal-wrapper">
                <p>Importe de la factura a enviar (sin IVA)</p>
                <input
                    type="number"
                    name="value"
                    onChange={(event) => handleAmmountChange(event.target.value)}
                    value={newPrice}
                    className="invoice-modal-input"
                />
                <span className={ammountError ? "error" : "hidden"}> El monto minimo es de 1€!</span>
            </div>
            <div className="invoice-modal-wrapper">
                <p>  Direccion de correo electronico</p>
                <input
                    type="email"
                    name="mail"
                    onChange={(event) => handleChangeEmail(event.target.value)}
                    onBlur={(event) => handleChangeEmail(event.target.value)}
                    value={email}
                    className="invoice-modal-input"
                />
                <span className={emailError ? "error" : "hidden"}> Introduce una direccion de correo valida !</span>
                <button onClick={onSendEmail} className="invoice-modal-button" disabled={disabled}>Enviar</button>
            </div>

        </MainModal>
    )
}

export default InvoiceModal;